import React, { Component } from 'react';
import { connect } from 'dva';
import '@/styles/containers/home/index.less';
import { framework_tool, component_tool } from '@/tool'

let {
  WizLayout
} = component_tool;
const { WizContainer, modelUtils } = framework_tool


class Home extends WizContainer {

  componentName = 'Home';

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  _render() {
    return (
      <WizLayout className='manager-home'>
        <img src={constants.files.sys_home_img} />
      </WizLayout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(Home);
